export const SPORT_TYPE_MAP = {
  1: 'бадминтон',
  2: 'настольный теннис',
  3: 'сквош',
}

export const SPORT_TYPE_REVERSE_MAP = {
  бадминтон: 1,
  'настольный теннис': 2,
  сквош: 3,
}

export function sportTypeToInt(sportTypeStr) {
  if (typeof sportTypeStr === 'number') {
    return sportTypeStr
  }

  if (!sportTypeStr) {
    return null
  }

  return SPORT_TYPE_REVERSE_MAP[sportTypeStr.trim().toLowerCase()] ?? null
}

export function getSalaryDictTitle(salaryEntry) {
  if (!salaryEntry) {
    return 'Справочник не найден'
  }

  const sport = SPORT_TYPE_MAP[salaryEntry.sport_type] || salaryEntry.sport_type
  const trainer = salaryEntry.trainer_name || salaryEntry.trainer?.name || ''
  const prefix = trainer ? `${trainer}, ` : ''

  return `${prefix}кат. ${salaryEntry.category}, ${sport} — ${salaryEntry.price} ₽/ч`
}

export function findSalaryEntry(trainerId, category, sportType, salaryDict) {
  if (sportType == null) {
    return {
      salaryEntry: null,
      foundBy: null,
      salaryDictTitle: 'Справочник не найден',
    }
  }

  let salaryEntry = null
  let foundBy = null

  if (trainerId) {
    salaryEntry = (salaryDict || []).find(
      entry => entry.trainer?.yc_id === trainerId && entry.sport_type === sportType,
    )

    if (salaryEntry) {
      foundBy = `trainer_id=${trainerId}, sport_type=${sportType}`
    }
  }

  if (!salaryEntry && category) {
    salaryEntry = (salaryDict || []).find(
      entry => entry.trainer === null
        && entry.category === category
        && entry.sport_type === sportType,
    )

    if (salaryEntry) {
      foundBy = `category=${category}, sport_type=${sportType}`
    }
  }

  return {
    salaryEntry: salaryEntry || null,
    foundBy,
    salaryDictTitle: getSalaryDictTitle(salaryEntry),
  }
}

export function getTrainingDurationHours(record) {
  if (record?.start && record?.end) {
    const start = new Date(record.start)
    const end = new Date(record.end)
    const diffMs = end - start

    if (diffMs > 0) {
      return diffMs / (1000 * 60 * 60)
    }
  }

  return 1
}

export function formatTrainingDuration(record) {
  const hours = getTrainingDurationHours(record)
  const totalMinutes = Math.round(hours * 60)
  const wholeHours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  if (wholeHours > 0 && minutes > 0) {
    return `${wholeHours} ч ${minutes} мин`
  }

  if (wholeHours > 0) {
    return `${wholeHours} ч`
  }

  return `${minutes} мин`
}

function formatHoursForFormula(hours) {
  const rounded = Math.round(hours * 100) / 100

  if (rounded % 1 === 0) {
    return String(rounded)
  }

  return rounded.toFixed(2).replace(/\.?0+$/, '')
}

export function buildSalaryFormula(record, salaryEntry) {
  if (!salaryEntry) {
    return 'Справочник не найден'
  }

  const hours = getTrainingDurationHours(record)
  const hoursStr = formatHoursForFormula(hours)
  const pricePerHour = salaryEntry.price || 0
  const splitHourPrice = salaryEntry.split_hour_price || 0

  const parts = [`${pricePerHour} × ${hoursStr} ч`]

  if (record?.split === true && splitHourPrice > 0) {
    parts.push(`${splitHourPrice} × ${hoursStr} ч (split)`)
  }

  const amount = calcRecordSalary(record, salaryEntry)

  return `${parts.join(' + ')} = ${amount} ₽`
}

export function calcRecordSalary(record, salaryEntry) {
  const hours = getTrainingDurationHours(record)
  const pricePerHour = salaryEntry?.price || 0
  const splitHourPrice = salaryEntry?.split_hour_price || 0

  let amount = pricePerHour * hours

  if (record?.split === true) {
    amount += splitHourPrice * hours
  }

  return Math.round(amount)
}

export function calcTrainerSalary(trainer, salaryLookup) {
  const salaryEntry = salaryLookup?.salaryEntry ?? salaryLookup
  const foundBy = salaryLookup?.foundBy ?? null
  const salaryDictTitle = salaryLookup?.salaryDictTitle
    ?? getSalaryDictTitle(salaryEntry)

  const records = (trainer.records || []).map(record => ({
    ...record,
    duration_hours: getTrainingDurationHours(record),
    salary: calcRecordSalary(record, salaryEntry),
    salary_formula: buildSalaryFormula(record, salaryEntry),
    salary_dict_title: salaryDictTitle,
    salary_dict_found_by: foundBy,
  }))

  const totalSalary = records.reduce((sum, record) => sum + record.salary, 0)

  return {
    records,
    totalSalary,
  }
}
